import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import BenefitItem from "../generic/BenefitItem";

const DataDriven = () => {
  const benefits = [
    "Validating marketing spend and ROI with precise attribution",
    "Quickly identifying high-performing campaigns and user acquisition channels.",
    "Simplifying cross-platform tracking without complex integrations.",
    "Delivering clear, actionable data without unnecessary clutter.",
  ];
  const benefitsRed = [
    "Granular in-app analytics or feature-level tracking",
    "Complex dashboards packed with interaction data",
    "Heavy analytics setups or event instrumentation",
  ];
  return (
    <FullPageContainer>
      <Container id={"dataDriven"}>
        <TextWrapper>
          <Title>Data-Driven Growth Made Simple</Title>
        </TextWrapper>
        <Content>
          <ItemsWrapper>
            <ItemsTitle>
              Grovs is the ideal solution for Data & Analytics teams focused on:
            </ItemsTitle>
            {benefits.map((item, index) => (
              <BenefitItem key={index} benefit={true} text={item} />
            ))}
          </ItemsWrapper>
          <ItemsWrapper>
            <ItemsTitle>
              Grovs is built for clarity — perfect for teams who don’t need:
            </ItemsTitle>
            {benefitsRed.map((item, index) => (
              <BenefitItem key={index} benefit={false} text={item} />
            ))}
          </ItemsWrapper>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default DataDriven;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: start;
  z-index: 2;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;
const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  margin: auto;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;
const ItemsTitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
`;
